function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import style from './Selector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";

const Selector = ({
  leftDecoration,
  rightDecoration,
  title,
  onClick,
  classes: {
    button: buttonClass,
    title: titleClass
  },
  buttonAttributes
}) => ___EmotionJSX(Button, _extends({
  css: style.Button.base,
  onClick: onClick,
  className: buttonClass
}, buttonAttributes), ___EmotionJSX("div", {
  css: style.Title.base
}, leftDecoration && ___EmotionJSX("div", {
  css: style.Decoration.left
}, leftDecoration), title && ___EmotionJSX("div", {
  css: style.Title.copy,
  className: titleClass
}, title), rightDecoration));

Selector.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    title: PropTypes.string,
    button: PropTypes.string
  }),
  leftDecoration: PropTypes.element,
  rightDecoration: PropTypes.element,
  buttonAttributes: PropTypes.object
};
Selector.defaultProps = {
  title: '',
  leftDecoration: null,
  rightDecoration: null,
  onClick: () => {},
  classes: {},
  buttonAttributes: {}
};
export default React.memo(Selector);
//# sourceMappingURL=Selector.js.map